// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIoi_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#9AB3DB" d="M0 0H24V24H0z"/>
  <path fill="#EDF2F7" d="M0 0H24V24H0z"/>
  <path fill="#003ECD" d="M1 1H23V23H1z"/>
  <g filter="url(#a)">
    <circle cx="12" cy="12" r="10" fill="#31B9FF"/>
  </g>
  <g filter="url(#b)">
    <circle cx="12" cy="12" r="9" fill="#4EE9B9"/>
  </g>
  <g filter="url(#c)">
    <circle cx="12" cy="12" r="8" fill="#48D965"/>
  </g>
  <g filter="url(#d)">
    <circle cx="12" cy="12" r="8" fill="#48D965"/>
  </g>
  <g filter="url(#e)">
    <circle cx="12" cy="12" r="7" fill="#FFD562"/>
  </g>
  <g filter="url(#f)">
    <circle cx="12" cy="12" r="7" fill="#FFD562"/>
  </g>
  <g filter="url(#g)">
    <circle cx="12" cy="12" r="5" fill="#F7895A"/>
  </g>
  <g filter="url(#h)">
    <circle cx="12" cy="12" r="2" fill="#E04747"/>
  </g>
  <g filter="url(#i)">
    <circle cx="12" cy="12" r="2" fill="#E04747"/>
  </g>
  <g filter="url(#j)">
    <circle cx="12" cy="12" r="2" fill="#E04747"/>
  </g>
  <defs>
    <filter id="a" x="1" y="1" width="22" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="b" x="2" y="2" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="c" x="3" y="3" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="d" x="3" y="3" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="e" x="3" y="3" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="f" x="3" y="3" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="g" x="5" y="5" width="14" height="14" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="h" x="7" y="7" width="10" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="i" x="7" y="7" width="10" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_21396_235"/>
    </filter>
    <filter id="j" x="8.5" y="8.5" width="7" height="7" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".75" result="effect1_foregroundBlur_21396_235"/>
    </filter>
  </defs>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#EDF2F7" d="M0 0H32V32H0z"/>
  <path fill="#003ECD" d="M1 1H31V31H1z"/>
  <g filter="url(#a)">
    <circle cx="16" cy="16" r="13.636" fill="#31B9FF"/>
  </g>
  <g filter="url(#b)">
    <circle cx="16" cy="15.999" r="12.273" fill="#4EE9B9"/>
  </g>
  <g filter="url(#c)">
    <circle cx="16" cy="16.001" r="10.909" fill="#48D965"/>
  </g>
  <g filter="url(#d)">
    <circle cx="16" cy="16.001" r="10.909" fill="#48D965"/>
  </g>
  <g filter="url(#e)">
    <circle cx="16" cy="16" r="9.545" fill="#FFD562"/>
  </g>
  <g filter="url(#f)">
    <circle cx="16" cy="16" r="9.545" fill="#FFD562"/>
  </g>
  <g filter="url(#g)">
    <circle cx="16" cy="16" r="6.818" fill="#F7895A"/>
  </g>
  <g filter="url(#h)">
    <circle cx="16" cy="16.001" r="2.727" fill="#E04747"/>
  </g>
  <g filter="url(#i)">
    <circle cx="16" cy="16.001" r="2.727" fill="#E04747"/>
  </g>
  <g filter="url(#j)">
    <circle cx="16" cy="16.001" r="2.727" fill="#E04747"/>
  </g>
  <defs>
    <filter id="a" x="1.363" y="1.363" width="29.273" height="29.273" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="b" x="2.727" y="2.727" width="26.545" height="26.545" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="c" x="4.091" y="4.092" width="23.818" height="23.818" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="d" x="4.091" y="4.092" width="23.818" height="23.818" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="e" x="4.454" y="4.455" width="23.091" height="23.092" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="f" x="4.454" y="4.455" width="23.091" height="23.092" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="g" x="7.182" y="7.182" width="17.636" height="17.637" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="h" x="10.273" y="10.273" width="11.455" height="11.455" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="i" x="10.273" y="10.273" width="11.455" height="11.455" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_21396_234"/>
    </filter>
    <filter id="j" x="11.773" y="11.773" width="8.455" height="8.455" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation=".75" result="effect1_foregroundBlur_21396_234"/>
    </filter>
  </defs>
</svg>
`;
/**
 * IconMedIoi is a generated icon component.
 */
let IconMedIoi = IconMedIoi_1 = class IconMedIoi extends IconBaseElement {
    render() {
        return html `${IconMedIoi_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIoi.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedIoi = IconMedIoi_1 = __decorate([
    customElement('zui-icon-med-ioi')
], IconMedIoi);
export { IconMedIoi };
